String::dasherize = ->
	@.replace /_/g, "-"

String::undasherize = ->
	@.replace /-/g, "_"

String::removeStart = (start) ->
	@.slice start.length

String::removeEnd = (end) ->
	@.slice 0, @.indexOf(end)

# Convert alfaBetaGamma to alfa_beta_gamma
String::camelToSnake = (sep = '_') ->
	@.split(/(?=[A-Z])/).join(sep).toLowerCase()

# Convert alfa_beta_gamma to alfaBetaGamma
# Also works with "-" as separator.
String::snakeToCamel = ->
	@.toLowerCase().replace /([_-][a-z])/g, (group) ->
		group.toUpperCase().replace('_', '').replace('-', '')

# Convert alfa_beta_gamma to AlfaBetaGamma
# Also works with "-" as separator.
String::snakeToPascal = ->
	str = @.snakeToCamel()
	str.slice(0, 1).toUpperCase() + str.slice 1

String::htmlEntities = ->
	@.replace /[\u00A0-\u9999<>\&]/g, (i) => '&#'+i.charCodeAt(0)+';'

String::firstPart = (end) ->
	ellipsis = if end < @.length then '…' else ''
	(@.substring 0, end)+ellipsis

String::stripHTML = ->
	container = document.createElement 'div'
	container.innerHTML = @
	container.textContent || container.innerText

String::isNumber = ->
	regExp = new RegExp /^-?\d*[.,]?\d*$/
	return @.trim() not in ['', '-'] and regExp.test @

Array::last = -> @[@length - 1]

Array::allEqual = -> @.every (item) -> item == @[0]

String::ucfirst = ->
	if @.length > 0 then @[0].toUpperCase() + @.slice(1) else ''

String::lcfirst = ->
	if @.length > 0 then @[0].toLowerCase() + @.slice(1) else ''

# Pad a string with some character (default '0').
String::pad = (width, defaultZ) ->
	nStr = @
	n = if isNaN(Number(nStr)) then nStr else Number(nStr)
	neg = n < 0
	nAbs = if neg then -n else n
	z = defaultZ || '0'
	nAbsStr = nAbs + ''
	res = if nAbsStr.length >= width
		nAbsStr
	else
		new Array(width - nAbsStr.length + 1).join(z) + nAbsStr
	if neg
		'-' + res
	else
		res

#console.assert 'helloThereBuddy'.camelToSnake(), 'hello_there_buddy'
#console.assert 'hello_there_buddy'.snakeToCamel(), 'helloThereBuddy'
#console.assert 'hello_there_buddy'.snakeToPascal(), 'HelloThereBuddy'

class pgweb.Main
	
	constructor: ->
		
	instance = null
	
	pageX = null
	pageY = null
	
	tooltipTimeout = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	@init: ->
		# This mitigates that when the browser window is resized, the trends chart can only grow, not shrink.
		$(window).bind "resize", ->
			width = $(document).width() - 40
			$(".trends-chart-container").css("width", width);
			$(".trend-tool-container").css("width", width);
			$(".analysis-container").css("width", width);
			$(".linechart-container").css("width", width);
			$(".heatmapchart-container").css("width", width);
			$(".heatmap-vertical-chart-container").css("width", width);

		$(document).on 'pagecreate', '[data-role=page]', (event) ->
			$(-> pgweb.Main.inst().initAfterPageLoad())

		$(document).on 'pageshow', (event) ->
			pageId = $($('[data-role=page]')[0]).prop('id')
			action = $.url().param().action
			if pgweb.Main.inst().getTermsLaterCookie() or $('#terms-box').length == 0 or pageId == 'loginPage' or action == 'showTerms'
				$('[data-role=page]').css 'margin-top', 0
			else
				$('[data-role=page]').css 'margin-top', 80
				$('#terms-box').show()
			#if $.url().param().openPanel
				#$("#menuPanel").panel 'option', 'animate', false
				#$('#menuPanel').panel 'open'
				#$("#menuPanel").panel 'option', 'animate', true

			if $('#message-bubble-text').html()
				if $('#message-bubble-text').html().trim()
					$('#message-warning-button').show()

		$('body').on 'click', '.function-link', ->
			closestCollapsible = $(@).closest '.network-collapsible'
			if closestCollapsible.length == 1
				networkId = lastNum closestCollapsible.prop 'id'
			else
				networkId = $.url().param().networkId
			functionId = lastNum @.id
			f = functions['network'+networkId]['function'+functionId]
			pgweb.Main.onFunctionLinkClick f.showHow, f.url, f.width, f.height
	
		$(document).on 'mousemove', (e) ->
			pageX = e.pageX
			pageY = e.pageY
		
		$(document).on 'pageshow', '[data-role="page"]', (event) ->

			# Selector for area changed.
			$('body').on 'change', '#selected_area_id', (e) ->
				areaId = $(e.target).val()
				networkId = $.url().param().networkId
				moduleTypeId = $.url().param().moduleTypeId
				idHash = pgwebGetCookie 'idHash'
				pgwebSetCookie 'area_network'+networkId+'_'+idHash, areaId, 90
				if $.url().param().moduleId
					# We are on a module level page. Switch to the module list page.
					location.href = "?action=showModules&networkId=#{networkId}&moduleTypeId=#{moduleTypeId}"
				else
					# We are on a network level page. Just reload.
					location.href = $.url().attr 'source'

		$('body').on 'click', '#message-warning-button', ->
			pgweb.ErrorDialog.inst().show t.MainPage_Messages, $('#message-bubble-text').html()

	@onFunctionLinkClick: (showHow, url, width, height) ->
		ret = true
		if showHow == 3 # Open as popup
			ret = false
			$('.function-popup-iframe').remove()
			popupId = '#function-popup'
			$(popupId).append('<iframe class="function-popup-iframe"></iframe>');
			$(popupId).popup 'open'
			$(popupId+' iframe').attr 'src', url
			$(popupId).css 'width', width
			$(popupId).css 'height', height
		ret
	
	initAfterPageLoad: ->
		currentAutoUpdateIsOn = @getAutoUpdateCookie()
		@setAutoUpdateButtonOn currentAutoUpdateIsOn

		$('body').off 'change', '#auto-update-onoff'
		$('body').on 'change', '#auto-update-onoff', (event) =>
			@setAutoUpdateCookie $('#auto-update-onoff').val() == "on"

		$('#terms-accept-button').off 'click'
		$('#terms-accept-button').on 'click', (event) =>
			@onAcceptTerms()
		
		$('#terms-later-button').off
		$('#terms-later-button').on 'click', (event) =>
			@onAcceptTermsLater()

	@showTooltip: (html) ->
		clearTimeout tooltipTimeout
		$('#general-tooltip').css 'top', pageY+20
		$('#general-tooltip').css 'left', pageX-10
		$('#general-tooltip').html html
		$('#general-tooltip').show()
		tooltipTimeout = window.setTimeout ->
			$('#general-tooltip').hide()
		, 10000

	@removeTooltip: (selector) ->
		clearTimeout tooltipTimeout
		$('#general-tooltip').hide()

	onAcceptTerms: ->
		$.getJSON 'ajax/user/acceptTerms.php', (data, textStatus, jqXHR) ->
			if data.result != 'OK'
				alert 'Unable to register acceptence of terms!'
			else
				$('#terms-box').hide ->
					$('[data-role=page]').css 'margin-top', 0
					$('#terms-box').remove()
					$('#terms-accept-button').hide()
	
	onAcceptTermsLater: ->
		@setTermsLaterCookie true
		$('#terms-box').hide ->
			$('[data-role=page]').css 'margin-top', 0
	
	autoUpdateButtonIsOn: ->
		@getAutoUpdateCookie()

	setAutoUpdateButtonOn: (bool) ->
		@setAutoUpdateCookie bool
		if bool
			$('.auto-update-onoff').val 'on'
		else
			$('.auto-update-onoff').val 'off'
		$('.auto-update-onoff').slider('refresh');

	getTermsLaterCookie: ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return false
		Number(pgwebGetCookie 'terms_later_'+idHash) == 1

	setTermsLaterCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return
		pgwebSetCookie 'terms_later_'+idHash, Number(bool), 3 # Days

	getAutoUpdateCookie: ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return false
		Number(pgwebGetCookie 'autoupdate_'+idHash) == 1
	
	setAutoUpdateCookie: (bool) ->
		idHash = pgwebGetCookie 'idHash'
		if !idHash then return
		pgwebSetCookie 'autoupdate_'+idHash, Number(bool), 90

	# Copy to the clipboard using the deprecated execCommand method.
	# execCommand("copy") requires text to be selected in a DOM element, so we
	# create a temporary textarea, select its content, and copy it.
	# position:fixed prevents the browser from scrolling to the element when it
	# receives focus, which would otherwise cause the page to jump.
	copyToClipboardOld: (text) ->
		if typeof document.execCommand == 'undefined'
			alert 'No support for clipboard in this browser!'
		else
			$("body").append $('<textarea id="tmp-clipboard" style="position:fixed;top:0;left:0;opacity:0">')
			# focus() has to be done *after* select(), strange.
			$('#tmp-clipboard').text(text).select().focus()
			res = document.execCommand "copy"
			$('#tmp-clipboard').remove()
			if res
				console.log 'Success.'
			else
				alert 'Copy to clipboard failed.'
		
	# Copy to the clipboard. We always run the old method synchronously since
	# navigator.clipboard.writeText() can be rejected even over HTTPS (e.g. due
	# to browser policy), and its Promise-based nature means user activation may
	# be lost by the time it resolves, causing it to fail silently. The modern
	# API is attempted afterwards to overwrite the clipboard if supported, but
	# the old method is the reliable fallback.
	copyToClipboard: (text) ->
		@copyToClipboardOld text
		navigator.clipboard?.writeText?(text)
	
	openInStrippedWindow: (url, windowName) ->
		window.open url, windowName, 'toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, directories=no, status=no'

	@openBaiduMap: (lat, lng) ->
		[lat, lng] = CoordinateConvert.wgs84ToBd09 [lat, lng]
		url  = 'http://api.map.baidu.com/marker?location='+lat+','+lng+'&output=html'
		window.open url, 'pgweb_map'
		
	@openGoogleMap: (lat, lng) ->
		url  = 'https://www.google.com/maps/place/'+lat+'+'+lng+'/@'+lat+','+lng+',15z'
		window.open url, 'pgweb_map'

	@emailValid: (mail) ->
		/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test mail

	@isStrongPassword: (password) ->
		# Deprecated alias. Use passwordStrengthIsOK().
		@passwordStrengthIsOK password

	# Converts iso time ('YYYY-MM-DDTHH:MM:SS') into unix time (milliseconds since 1970).
	# Unix time is used in Highcharts.
	@isoToUnixMilliTz: (iso, timezoneOffset) ->
		dt = Globalize.parseDate iso
		dtJSTime = dateTimeToJSTime dt # Unix time * 1000
		dtJSTimeTzCorrected = dtJSTime + timezoneOffset*60000
		dtJSTimeTzCorrected

	# Converts unix time (milliseconds since 1970) into iso time ('YYYY-MM-DDTHH:MM:SS').
	@unixMilliToIso: (unixMilli) ->
		d = new Date unixMilli
		d.toISOString().substring 0, 19

	@unixMilliToIsoTz: (unixMilli) ->
		dBrowser = new Date unixMilli
		dLocal = new Date (dBrowser.getTime() + dBrowser.getTimezoneOffset()*60000)
		dStr = Globalize.format dLocal, 'F'
		dStr

	# Converts a database time (yyyy-mm-dd hh:mm:ss) in UTC to a localized time string.
	@dbTimeUTCToGlobalizedFormat: (dbTime) ->
		time = new Date dbTime
		localTime = new Date(time.getTime() - time.getTimezoneOffset()*60000)
		(Globalize.format localTime, 'd') + ' ' + (Globalize.format localTime, 'T')

	# Returns distance [m] between two points in a map.
	# Points are given as [lat, lng].
	@distance: (point1, point2) ->
		latlng1 = L.latLng point1[0], point1[1]
		latlng2 = L.latLng point2[0], point2[1]
		latlng1.distanceTo latlng2

	# For example "AN1" --> "an1_color".
	@tagMeaningToColorMemberName: (tagMeaning) ->
		tagMeaning.toLowerCase()+'_color'

	# Check that the order of the alarm limits are correct.
	# The limit values can be NaN!
	@checkRightAlarmLimitOrder: (lolo, lo, hi, hihi) ->
		arr = [lolo, lo, hi, hihi].map (x, i) -> {index: i, limit: x}
		arr = arr.filter (a) ->	not isNaN a.limit # Remove all NaN values.
		arrUnsorted = Array.from arr # Clone.
		arrSorted = arr.toSorted (a, b) -> if a.limit < b.limit then -1 else if a.limit > b.limit then 1 else 0 # Sort.
		zipped = @zip arrUnsorted, arrSorted # Zip the two arrays.
		zipped.reduce ((acc, currVal) -> acc and currVal[0].index == currVal[1].index), true # All indexes identical?

	# Zip function, makes array of pairs from two arrays.
	@zip: (a1, a2) -> a1.map((x, i) -> [x, a2[i]])

	# Remove first letter 'f' if it exists.
	@removeFormatF: (format) ->
		format ?= ''
		if format.slice(0, 1) == 'f' then format.slice(1) else format

	# Given an array, return the most common value. Returns an object the value as a string!
	# Null values will also be returned as string 'null'.
	@mostCommonElement: (arr) ->
		dict = arr.reduce ((obj, val) -> Object.assign obj, {[val]: if !obj[val]? then 1 else obj[val]+1}), {}
		sortedPairs = Object.entries(dict).sort (a, b) -> if a[1] < b[1] then 1 else if a[1] > b[1] then -1 else 0
		{mostCommon: sortedPairs[0][0], sortedPairs: sortedPairs}

	@xor: (a, b) ->
		(a or b) and not (a and b)

	@getUpdateInterval: ->
		if pgweb.Login.inst().usernameFromCookie() == 'elias.waldhe@pipeguard.se' then 10000 else 60000

	@onPageShow: (cls, f) ->
		$(document).on 'pageshow', cls, f

	@onEvent: (eventName, selector, f) ->
		$('body').off eventName, selector
		$('body').on eventName, selector, f

	@getGPSPosition: ->
		try
			unless navigator.geolocation
				console.error "Geolocation is not supported by this browser."
				return Promise.resolve {coords: null, error: 'Not supported.'}
			new Promise (resolve, reject) ->
				navigator.geolocation.getCurrentPosition resolve, reject
			.then (position) ->
				{coords: [position.coords.latitude, position.coords.longitude], error: null}
			.catch (error) ->
				if error.code == 2
					console.error "Position unavailable."
				else if error.code == 3
					console.error "Timeout getting position."
				else
					console.error "Failed to get GPS position:", error.code, error.message
				{coords: null, error: error}
		catch error
			console.error "Failed to get GPS position:", error.message
			Promise.resolve {coords: null, error: error}

	perf = null

	@perf: (label, start) ->
		if start
			perf = performance.now()
		else
			end = performance.now()
			console.log "#{label} took #{end - perf} milliseconds"
			perf = end

	@wholeName: (firstname, surname) ->
		[firstname, surname].filter((a) -> a).join ' '

	@passwordStrengthIsOK: (password) ->
		# Canonical rule. Mirror of User::passwordStrengthErrors()
		# in model/user/User.php. Described by UserSettings_PasswordRequirements.
		return false if not password? or password.length < 8
		return false if not password.match(/[a-z]/)
		return false if not password.match(/[A-Z]/)
		return false if not password.match(/[0-9]/)
		return false if not password.match(/[^A-Za-z0-9]/)
		true

pgweb.Main.init()
$(-> pgweb.Main.inst())

#console.assert (pgweb.Main.mostCommonElement [3, null, null, 6, 5, 8, 5]) == '5'
#console.assert (pgweb.Main.mostCommonElement [3, 8, 8, null, null, 6, 5, 8, 5]) == '8'
#console.assert (pgweb.Main.mostCommonElement [3, 8, 8, null, null, null, null, 6, 5, 8, 5]) == 'null'

#console.log pgweb.Main.inst().checkAlarm '', 500, 200, 50, 20
#module = {
#	activation: true
#	an1: 44
#	an1_active: true
#	hihi_limit_an1: null
#	hi_limit_an1: null
#	lo_limit_an1: null
#	lolo_limit_an1: null
#	an2: 123
#	an2_active: true
#	hihi_limit_an2: 500
#	hi_limit_an2: 200
#	lo_limit_an2: 50
#	lolo_limit_an2: 20
#}
#console.log pgweb.Main.inst().anAlarm 1, null, module
#console.log pgweb.Main.inst().anColor 2, module
#console.log pgweb.Main.emailValid 'asdf@asdf..se'
